import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  className?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-body font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-hubble-accent focus:ring-offset-2 focus:ring-offset-hubble-bg';
  const variants = {
    primary: 'bg-hubble-primary text-white hover:bg-hubble-hover',
    outline: 'border border-hubble-primary text-hubble-primary hover:bg-hubble-primary/10',
    ghost: 'text-hubble-body hover:text-hubble-text hover:bg-hubble-card'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-116">
      {children}
    </motion.button>;
}